import { API } from 'api/config'
import { ViewOrganization } from 'interfaces'

export const getOrganizationViews = async (): Promise<
	ViewOrganization[] | null
> => {
	let res = null as ViewOrganization[] | null
	await API()
		.get(`/views`)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.error(error)
			}
		)
	return res
}
